<template>
  <div>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          {{ $t('legalInfo.title') }}
        </v-card-title>
        <v-card-text>
          {{ $t('legalInfo.full') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">
            {{ $t('legalInfo.btnCancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card flat>
      <v-card-text class="font-italic pa-0">
        {{ $t('legalInfo.short') }}
        <a class="text-decoration-underline" @click="dialog = true">
          {{ $t('legalInfo.link') }}
        </a>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'LegalInfo',
  data () {
    return {
      dialog: false
    }
  }
}
</script>

<style scoped></style>
